import { useEffect } from 'react';
import { timer } from 'rxjs';

export default (callback: () => void, intervalTime = 5000, initialDelay = 0) => {
  useEffect(() => {
    const source = timer(initialDelay, intervalTime);
    const subscription = source.subscribe(() => callback());

    return () => subscription.unsubscribe();
  }, [callback, initialDelay, intervalTime]);
};
